import { render, staticRenderFns } from "./PedidoUpdate.vue?vue&type=template&id=0e677e98"
import script from "./PedidoUpdate.vue?vue&type=script&lang=js"
export * from "./PedidoUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports